// extracted by mini-css-extract-plugin
export default {"wrapper":"kqtWr","title":"RJWRz","descriptionWrapper":"PNIqL","description":"G_a8_","gallery":"tKL87","link":"r_GoD","button":"ba1jg","separator":"To_b0"};